<obg-m-dialog-layout
	#dialog
	titleText="{{ 'cookie-settings.title' | translate }}"
	dialogId="cookie-settings"
	hideFooter="true"
>
	<obg-m-cookie-settings-container (submitClick)="closePopup()"></obg-m-cookie-settings-container>
</obg-m-dialog-layout>
